import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { NavGuard } from './guard/nav.guard';

// TODO: review how to hide UI before login
const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'homepage', pathMatch: 'full' },
      {
        path: 'homepage',
        loadChildren: () => import('./pages/homepage/homepage.module').then((m) => m.HomepageModule)
      },
      {
        path: 'sircles/:slug',
        loadChildren: () => import('./pages/sircles/sircles.module').then((m) => m.SirclesModule)
      },
      { path: 'roles/:id', loadChildren: () => import('./pages/roles/roles.module').then((m) => m.RolesModule) },
      {
        path: 'members/:slug',
        loadChildren: () => import('./pages/members/members.module').then((m) => m.MembersModule)
      },
      { path: 'faq', loadChildren: () => import('./pages/faq/faq.module').then((m) => m.FaqModule) },
      {
        path: 'no-core-members',
        canActivate: [NavGuard],
        loadChildren: () => import('./pages/no-core-members/no-core-members.module').then((m) => m.NoCoreMembersModule)
      },
      {
        path: 'search/:search',
        loadChildren: () => import('./pages/search/search.module').then((m) => m.SearchModule)
      },
      { path: '**', redirectTo: 'homepage', pathMatch: 'full' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
